import {pmNotificationStatusListApprovalStates, PmNotificationStatus} from '@domain/shifthandover'
import {RemoveFilterButton} from '@widgets/common-filters'
import React from 'react'

import {FilterDropDown, type CommonFilterDropDownProps} from './FilterDropDown'
import {PmNotificationStatusLabel} from './PmNotificationStatusLabel'
import {SelectAllButton} from './SelectAllButton'

export const PmNotificationStatusFilterDropDown: React.FC<
  CommonFilterDropDownProps<PmNotificationStatus>
> = (props) => {
  const {selectAll} = props
  return (
    <FilterDropDown
      {...props}
      options={pmNotificationStatusListApprovalStates}
      keyName="pmNotificationStatus"
      customTemplate={(status) => {
        return <PmNotificationStatusLabel status={status} />
      }}
      fullWidth={false}
      customDropDownFooter={(keyName) =>
        props.isCollapsible ? null : (
          <>
            <SelectAllButton
              keyName={keyName}
              selectAll={() =>
                selectAll && selectAll(keyName, pmNotificationStatusListApprovalStates)
              }
            />
            <RemoveFilterButton keyName={keyName} removeFilter={props.removeFilter} />
          </>
        )
      }
    />
  )
}
